/**
 * Verrie media → variant sync. When a shopper manually browses to a photo
 * in the gallery (thumbnail click, arrow, scroll, or drag), and that photo
 * is a specific variant's featured media, auto-select the matching Metal
 * option — so the button group and the metal badge follow the photo,
 * instead of only the photo following the button group.
 *
 * Relies on the native `slideshow:select` event (assets/slideshow.js) and
 * a small media-id -> option-value JSON map rendered by
 * snippets/metal-badge-verrie.liquid.
 */
function handleSlideSelect(event) {
  const mediaId = event.detail?.id;
  if (!mediaId) return;

  const root = event.target instanceof Element ? event.target.closest('.product-information') : null;
  if (!root) return;

  const mapScript = root.querySelector('[data-metal-media-map]');
  if (!mapScript) return;

  let map;
  try {
    map = JSON.parse(mapScript.textContent);
  } catch {
    return;
  }

  const metalValue = map[mediaId];
  if (!metalValue) return;

  const radios = root.querySelectorAll('.variant-option__button-label input[type="radio"]');
  for (const radio of radios) {
    if (radio instanceof HTMLInputElement && radio.value === metalValue && !radio.checked) {
      radio.click();
      break;
    }
  }
}

document.addEventListener('slideshow:select', handleSlideSelect);
